(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reducedMotion) {
    document.documentElement.classList.add('ak-reduced-motion');
    return;
  }

  document.documentElement.classList.add('ak-motion-enabled');

  const revealSelector = [
    '.ak-home .ak-section-heading',
    '.ak-home .ak-trust-grid',
    '.ak-home .ak-quick-card',
    '.ak-home .ak-product-card',
    '.ak-home .ak-finder-grid',
    '.ak-home .ak-home-video__copy',
    '.ak-home .ak-home-video__card',
    '.ak-home .ak-compare-row',
    '.ak-home .ak-reimbursement-grid',
    '.ak-home .ak-audience-card',
    '.ak-home .ak-story-copy',
    '.ak-home .ak-final-inner',
    '.ak-catalog .ak-catalog-hero__copy',
    '.ak-catalog .ak-catalog-proof',
    '.ak-catalog .ak-mobile-intents__grid > a',
    '.ak-catalog .ak-catalog-heading',
    '.ak-catalog .ak-catalog-card',
    '.ak-catalog .ak-catalog-support__grid > *',
    '.ak-catalog .ak-catalog-final__inner',
    '.ak-pdp-shell .ak-pdp-details > *'
  ].join(',');

  const reveal = (element) => {
    element.classList.add('is-visible');
    observer?.unobserve(element);
  };

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) reveal(entry.target);
        });
      }, { rootMargin: '0px 0px 120px 0px', threshold: 0.01 })
    : null;

  const initializeMotion = (root = document) => {
    root.querySelectorAll(revealSelector).forEach((element) => {
      if (element.dataset.akMotionReady === 'true') return;

      element.dataset.akMotionReady = 'true';
      element.classList.add('ak-motion-reveal');

      const siblings = element.parentElement
        ? Array.from(element.parentElement.children).filter((sibling) => sibling.matches?.(revealSelector))
        : [];
      const order = Math.max(0, siblings.indexOf(element));
      element.style.setProperty('--ak-motion-delay', `${Math.min(order, 3) * 45}ms`);

      const rect = element.getBoundingClientRect();
      if (!observer || rect.top < window.innerHeight * 1.05) reveal(element);
      else observer.observe(element);
    });
  };

  initializeMotion();
  document.addEventListener('shopify:section:load', (event) => initializeMotion(event.target));
})();
